// import { combineReducers } from "redux";

// // Front
// import Layout from "./layouts/reducer";

// // Authentication
// import Login from "./auth/login/reducer";
// import Account from "./auth/register/reducer";
// import ForgetPassword from "./auth/forgetpwd/reducer";
// import Profile from "./auth/profile/reducer";

// //Calendar
// import Calendar from "./calendar/reducer";
// //Chat
// import chat from "./chat/reducer";
// //Ecommerce
// import Ecommerce from "./ecommerce/reducer";

// //Project
// import Projects from "./projects/reducer";

// // Tasks
// import Tasks from "./tasks/reducer";
// //Form advanced
// import changeNumber from "./formAdvanced/reducer";

// //Crypto
// import Crypto from "./crypto/reducer";

// //TicketsList
// import Tickets from "./tickets/reducer";
// //Crm
// import Crm from "./crm/reducer";

// //Invoice
// import Invoice from "./invoice/reducer";

// //Mailbox
// import Mailbox from "./mailbox/reducer";

// // Dashboard Analytics
// import DashboardAnalytics from "./dashboardAnalytics/reducer";

// // Dashboard CRM
// import DashboardCRM from "./dashboardCRM/reducer";

// // Dashboard Ecommerce
// import DashboardEcommerce from "./dashboardEcommerce/reducer";

// // Dashboard Cryto
// import DashboardCrypto from "./dashboardCrypto/reducer";

// // Dashboard Cryto
// import DashboardProject from "./dashboardProject/reducer";

// // Dashboard NFT
// import DashboardNFT from "./dashboardNFT/reducer";

// // Pages > Team
// import Team from "./team/reducer";

// // File Manager
// import FileManager from "./fileManager/reducer"

// // To do
// import Todos from "./todos/reducer"

// // Job
// import Jobs from  './job/reducer'

// //API Key
// import APIKey from "./apikey/reducer";

// const rootReducer = combineReducers({
//     // public
//     Layout,
//     Login,
//     Account,
//     ForgetPassword,
//     Profile,
//     Calendar,
//     chat,
//     Projects,
//     Ecommerce,
//     Tasks,
//     changeNumber,
//     Crypto,
//     Tickets,
//     Crm,
//     Invoice,
//     Mailbox,
//     DashboardAnalytics,
//     DashboardCRM,
//     DashboardEcommerce,
//     DashboardCrypto,
//     DashboardProject,
//     DashboardNFT,
//     Team,
//     FileManager,
//     Todos,
//     Jobs,
//     APIKey
// });

// export default rootReducer;

import {
    GET_PROJECT_LIST,
    API_RESPONSE_SUCCESS,
    API_RESPONSE_ERROR,
    DELETE_PROJECT_LIST_SUCCESS,
    DELETE_PROJECT_LIST_FAIL,
    ADD_PROJECT_LIST_SUCCESS,
    ADD_PROJECT_LIST_FAIL,
    UPDATE_PROJECT_LIST_SUCCESS,
    UPDATE_PROJECT_LIST_FAIL,
} from "./actionType";

const INIT_STATE = {
    projectLists: [],
    error: {},
};

const Projects = (state = INIT_STATE, action) => {
    switch (action.type) {
        case API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case GET_PROJECT_LIST:
                    return {
                        ...state,
                        projectLists: action.payload.data,
                    };
                default:
                    return { ...state };
            }
        case API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case GET_PROJECT_LIST:
                    return {
                        ...state,
                        error: action.payload.error,
                    };
                default:
                    return { ...state };
            }
        case DELETE_PROJECT_LIST_SUCCESS:
            return {
                ...state,
                projectLists: state.projectLists.filter(project => project.id.toString() !== action.payload.id.toString())
            };
        case DELETE_PROJECT_LIST_FAIL:
            return {
                ...state,
                error: action.payload
            };
        case ADD_PROJECT_LIST_SUCCESS:
            return {
                ...state,
                projectLists: [...state.projectLists, action.payload],
            };
        case ADD_PROJECT_LIST_FAIL:
            return {
                ...state,
                error: action.payload,
            };
        case UPDATE_PROJECT_LIST_SUCCESS:
            return {
                ...state,
                projectLists: state.projectLists.map(project =>
                    project._id.toString() === action.payload.data._id.toString()
                        ? { ...project, ...action.payload.data }
                        : project
                ),
            };
        case UPDATE_PROJECT_LIST_FAIL:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return { ...state };

    }
};

export default Projects;